/** ISO-8601 week-of-year, matching the number the backend computes with
 *  `isocalendar()[1]` for the portfolio Capacity views -- so "S1" always
 *  means the calendar's first week, never just "whichever column happens to
 *  be first in the window currently on screen". */
export function isoWeekNumber(iso) {
  const d = new Date(iso + 'T00:00:00')
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7))
  const firstThursday = new Date(d.getFullYear(), 0, 4)
  firstThursday.setDate(firstThursday.getDate() + 3 - ((firstThursday.getDay() + 6) % 7))
  return 1 + Math.round((d - firstThursday) / (7 * 24 * 3600 * 1000))
}

/** Whether any of a week's five working days falls in `year`/`month`. */
export function weekTouchesMonth(monday, year, month) {
  const d0 = new Date(monday + 'T12:00:00')
  for (let i = 0; i < 5; i++) {
    const d = new Date(d0)
    d.setDate(d.getDate() + i)
    if (d.getFullYear() === year && d.getMonth() + 1 === month) return true
  }
  return false
}
